import { put, call, takeEvery } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { startSubmit, stopSubmit, reset } from 'redux-form'
import * as colors from 'material-ui/styles/colors';

import * as commons from '../commons'
import * as actions from '../actions'
import * as types from '../constants/ActionTypes'

import moment from 'moment'
import _ from 'lodash'

const createDays = (startDay, endDay) => {

  const diff = endDay.diff(startDay, 'days')

  let tmpStartDay = startDay
  let days = []
  _.times(diff + 1, (n) => {
      days.push(tmpStartDay.format('YYYY/MM/DD'));  // your format
      tmpStartDay.add(1, 'day');
  });

  return days

}

export function* getRoumuEvents(action) {

  const {userId, start, end} = action.payload

  yield put(actions.reducerAppLoading(true))

  const events = yield call(commons.get2, `/bg/roumu/${userId}/${start}/${end}`)
  const eventsCheck = yield call(errorCheck, events)
  if (!eventsCheck) {
    return
  }

  const startDay = moment(start, 'YYYYMMDDHHmmss')
  const endDay = moment(end, 'YYYYMMDDHHmmss')

  let removeDays = []
  if (startDay.format('YYYYMMDD') !== endDay.format('YYYYMMDD')) {
    removeDays = createDays(startDay, endDay)
  } else {
    removeDays.push(startDay.format('YYYY/MM/DD'))
  }


  yield put(actions.reducerRoumuRemoveEvents(removeDays))
  yield call(delay, 100)
  yield put(actions.reducerRoumuRemoveEvents(null))

  yield put(actions.reducerRoumuSetEvents(events.result))

  yield put(actions.reducerAppLoading(false))

}


export function* registRoumuEvent(action) {
  // const {event, next} = action.payload
  const {next, yosanCosts} = action.payload
  let {formData} = action.payload

  yield put(startSubmit('roumuForm'))
  yield put(actions.reducerAppLoading(true))

  let yosanId
  if (formData.costId && yosanCosts) {
    const yosanCost = yosanCosts.find(x => x.costId == formData.costId)
    if (yosanCost) {
      yosanId = yosanCost.yosanId
    } else {
      yosanId = ''
    }
  } else {
    yosanId = ''
  }

  if (formData.startTime) {
      formData.startTime = formData.startTime.replace(/[０-９：]/g, (s) => {
          return String.fromCharCode(s.charCodeAt(0) - 65248);
      });
  }

  if (formData.endTime) {
      formData.endTime = formData.endTime.replace(/[０-９：]/g, (s) => {
          return String.fromCharCode(s.charCodeAt(0) - 65248);
      });
  }

  const newFormData = Object.assign({}, formData, {yosanId: yosanId})

  let registRes;
  if (newFormData.delete) {
      registRes = yield call(commons.delete2, `/bg/roumu/${newFormData.id}?status=${newFormData.status}`) 
  } else {
    if (newFormData.id) {
      registRes = yield call(commons.put2, `/bg/roumu/${newFormData.id}`, newFormData) 
    } else {
      registRes = yield call(commons.post2, `/bg/roumu`, newFormData) 
    }
  }

  const registResCheck = yield call(errorCheck, registRes)
  if (!registResCheck) {
    return
  }

  // const result = yield call(commons.registRoumuEvent, eventData)

  // if (result.error) {
  //   yield put(stopSubmit('roumuForm', { ...result.error.field, _error: result.error.message }))
  //   yield put(actions.reducerAppLoading(false))
  //   return
  // }

  // yield put(actions.reducerRoumuRemoveEvents([formData.date]))
  // yield call(delay, 100)
  // yield put(actions.reducerRoumuRemoveEvents(null))


  const reloadDate = newFormData.date.replace(/\//g, '')
  const reloadDateStart = `${reloadDate}000000`
  const reloadDateEnd = `${reloadDate}235959`

  // const reloadEvents = yield call(commons.getRoumuEvents, formData.userId, reloadDateStart, reloadDateEnd)

  // yield put(actions.reducerRoumuSetEvents(reloadEvents.result))


  yield put(actions.systemRoumuGetEvents(newFormData.userId, reloadDateStart, reloadDateEnd))

  yield call(delay, 100)
  yield put(stopSubmit('roumuForm'))
  yield put(actions.reducerAppLoading(false))

  if (!next) {
    yield put(actions.reducerRoumuFormClose())
  } else {
    yield put(actions.reducerRoumuFormNext(formData))
  }

}


export function* init(action) {

  const {userId, start, end} = action.payload

  yield put(startSubmit('roumuForm'))
  yield put(actions.reducerAppLoading(true))

  const paidHoliday = yield call(commons.get2, `/bg/v2/paidHoliday/current/${userId}`)

  // 労務取得
  const events = yield call(commons.get2, `/bg/roumu/${userId}/${start}/${end}`)
  const eventsCheck = yield call(errorCheck, events)
  if (!eventsCheck) {
    return
  } 
  
  yield put(actions.reducerRoumuSetEvents(events.result))

  const kenmeiRes = yield call(commons.get2, `/bg/master/kenmei`)
  const kenmeiResCheck = yield call(errorCheck, kenmeiRes)
  if (!kenmeiResCheck) {
    return
  }

  const workRes = yield call(commons.get2, `/bg/master/work`)
  const workResCheck = yield call(errorCheck, workRes)
  if (!workResCheck) {
    return
  }

  const userRes = yield call(commons.get2, `/bg/master/user/${userId}`)
  const userResCheck = yield call(errorCheck, userRes)
  if (!userResCheck) {
    return
  }

  yield put(actions.reducerRoumuUpdateStore(
    {editUserId: userId, editUserName: userRes.result.name, editUser: userRes.result, currentPaidHoliday: paidHoliday}))

  yield put(actions.reducerRoumuSetSelectData(kenmeiRes.result.list, workRes.result.list))

  yield put(stopSubmit('roumuForm'))
  yield put(actions.reducerAppLoading(false))

  // const workHolidayRes = yield call(commons.get, `http://localhost:5000/api/roumu/workHoliday/${userId}`) 

  // if (workHolidayRes.fetchError) {
  //   console.log(workHolidayRes)
  // } else {
  //   yield put(actions.reducerRoumuSetWorkHolidayDates(workHolidayRes.result))
  // }

}

export function* openRoumuForm(action) {

  let {event, kenmeiCodes} = action.payload

  if (!event.id && window.localStorage) {

    let localStorageForm = window.localStorage.getItem('roumu')
    if (localStorageForm) {
      localStorageForm = JSON.parse(localStorageForm)
    } else {
      localStorageForm = {}
    }

    let localStorageCurrentKenmei = window.localStorage.getItem('currentKenmei')
    if (localStorageCurrentKenmei) {
      localStorageCurrentKenmei = JSON.parse(localStorageCurrentKenmei)
    } else {
      localStorageCurrentKenmei = {
        kenmeiName: "ー",
        customerName: "ー"
      }
    }


    localStorageForm.date = event.date

    yield put(actions.reducerRoumuFormOpen(
      localStorageForm,
      localStorageCurrentKenmei
    ))

    return

  }


  let currentKenmei = {
    kenmeiName: "ー",
    customerName: "ー"
  }

  if (event.kenmeiName) {
    currentKenmei = {
      kenmeiName: event.kenmeiName,
      customerName: event.customerName
    }
  }

  if (event.kenmeiCode) {
    yield call(handleGetYosanCosts,{
      payload: {
        id: event.yosanId,
        kenmeiCode: event.kenmeiCode,
      }
    })
  }

  yield put(actions.reducerRoumuFormOpen(
    event,
    currentKenmei
  ))

}

export function* closeRoumuForm(action) {
  yield put(actions.reducerRoumuFormClose())
}

function* approval(action) {

  yield put(actions.reducerAppLoading(true))

  const updateData = action.payload

  let registRes;
  if (updateData.roumuId) {
    registRes = yield call(commons.put2, `/bg/roumu/${updateData.roumuId}`, {approval: 1, reply: updateData.reply})
  } else {
    registRes = yield call(commons.put2, `/bg/roumu/approval/${updateData.userId}`, 
      {date: updateData.date, approval: 1, reply: updateData.reply}
    )
  }

  const registResCheck = yield call(errorCheck, registRes)
  if (!registResCheck) {
    return
  }

  const reloadDate = updateData.date.replace(/\//g, '')
  const reloadDateStart = `${reloadDate}000000`
  const reloadDateEnd = `${reloadDate}235959`

  yield put(actions.systemRoumuGetEvents(updateData.userId, reloadDateStart, reloadDateEnd))

  if (updateData.roumuId) {
    yield put(actions.reducerRoumuFormClose())
  } else {
    yield put(actions.reducerRoumuApprovalDialogClose())
  }

  yield call(delay, 100)
  yield put(actions.reducerAppLoading(false))

}


function* handleRegistSubHoliday(action) {

  const {form} = action.payload

  yield put(startSubmit('subHolidayForm'))
  yield put(actions.reducerAppLoading(true))

  const subHolidayRes = yield call(commons.post, 'http://localhost:5000/api/roumu/subHoliday', form) 
  if (subHolidayRes.fetchError) {
    yield put(stopSubmit('subHolidayForm', { _error: '登録処理に失敗しました。' }))
    yield put(actions.reducerAppLoading(false))
    return
  }

  if (subHolidayRes.error) {
    const {field, message} = subHolidayRes.error
    yield put(stopSubmit('subHolidayForm', { ...field, _error: message }))
    yield put(actions.reducerAppLoading(false))
    return
  }

  const workHolidayRes = yield call(commons.get, `http://localhost:5000/api/roumu/workHoliday/${form.userId}`) 
  
  if (workHolidayRes.fetchError || workHolidayRes.error) {
  } else {
    yield put(actions.reducerRoumuSetWorkHolidayDates(workHolidayRes.result))
  }

  const reloadDate = moment(form.subHolidayDate, 'YYYY/MM/DD').format('YYYYMMDD')
  const reloadDateStart = `${reloadDate}000000`
  const reloadDateEnd = `${reloadDate}235959`

  yield put(actions.systemRoumuGetEvents(form.userId, reloadDateStart, reloadDateEnd))

  yield put(actions.reducerAppLoading(false))
  yield put(stopSubmit('subHolidayForm'))
  yield put(actions.reducerRoumuSubHolidayFormClose())

  // yield put(startSubmit('subHolidayForm'))
  // yield put(actions.reducerAppLoading(true))

  // const res = yield call(commons.post, 'http://localhost:5000/login', form) 

  // if (res.fetchError) {
  //   yield put(stopSubmit('subHolidayForm', { _error: '登録処理に失敗しました。' }))
  //   yield put(actions.reducerAppLoading(false))
  //   return
  // }
  
  // if (res.error) {
  //   const {field, message} = res.error
  //   yield put(stopSubmit('subHolidayForm', { ...field, _error: message }))
  // } else {

  //   yield put(stopSubmit('subHolidayForm'))
  //   yield put(actions.reducerRoumuSubHolidayFormClose())

  // }

  // yield put(actions.reducerAppLoading(false))

}


function* errorCheck(res) {

  if (!res) {
    yield put(stopSubmit(`roumuForm`))
    yield put(actions.reducerSnackBar(true, '通信処理に失敗しました。', colors.red400))
    yield put(actions.reducerAppLoading(false))
    return
  }

  if (res.status && res.status == 401) {
    yield put(stopSubmit(`roumuForm`))
    yield put(actions.reducerSnackBar(true, 'セッションタイムアウト（30分）しました。', colors.red400))
    yield put(actions.reducerSetAuth({}, 9))
    yield put(actions.reducerAppLoading(false))
    return
  }

  if (res.fetchError || (res.status && res.status != 200)) {
    yield put(stopSubmit(`roumuForm`))
    yield put(actions.reducerSnackBar(true, '通信処理に失敗しました。', colors.red400))
    yield put(actions.reducerAppLoading(false))
    return false
  }
  
  if (res.error) {
    const {field, message} = res.error
    yield put(stopSubmit(`roumuForm`, { ...field }))
    yield put(actions.reducerSnackBar(true, message, colors.red400))
    yield put(actions.reducerAppLoading(false))
    return false
  }

  return true
}

export function* handleGetYosanCosts(action) {

  const {id, kenmeiCode, costId} = action.payload

  yield put(actions.reducerAppLoading(true))
  
  const roumuCostsRes = yield call(commons.get2, `/bg/roumu/roumuCosts/${kenmeiCode ? kenmeiCode : 'Z'}?yosanId=${id ? id : ''}`)

  const roumuCostsCheck = yield call(errorCheck, roumuCostsRes)
  if (!roumuCostsCheck) {
    return
  }

  yield put(actions.reducerRoumuSetYosanCosts(id, roumuCostsRes.result, roumuCostsRes.disable))
  yield call(delay, 100)
  yield put(actions.reducerAppLoading(false))

}

export function* handleGetWorkHoliday(action) {

  const {userId} = action.payload

  yield put(actions.reducerAppLoading(true))
 
  const workHolidayRes = yield call(commons.get2, `/bg/roumu/workHoliday/${userId}`)

  const workHolidayResCheck = yield call(errorCheck, workHolidayRes)
  if (!workHolidayResCheck) {
    return
  }
 
  yield put(actions.reducerRoumuSetWorkHoliday(workHolidayRes.result))

  yield call(delay, 100)
  yield put(actions.reducerAppLoading(false))

}

function* rootRoumu() {
  yield takeEvery(types.SYSTEM_ROUMU_INIT, init);
  yield takeEvery(types.SYSTEM_ROUMU_GET_EVENTS, getRoumuEvents);
  yield takeEvery(types.USER_ROUMU_FORM_CLOSE, closeRoumuForm);
  yield takeEvery(types.USER_ROUMU_FORM_OPEN, openRoumuForm);

  yield takeEvery(types.USER_ROUMU_REGIST_EVENT, registRoumuEvent);

  yield takeEvery(types.USER_ROUMU_APPROVAL, approval);

  yield takeEvery(types.USER_ROUMU_REGIST_SUB_HOLIDAY, handleRegistSubHoliday);

  yield takeEvery(types.SYSTEM_ROUMU_GET_YOSAN_COSTS, handleGetYosanCosts);
  yield takeEvery(types.SYSTEM_ROUMU_GET_WORK_HOLIDAY, handleGetWorkHoliday);
}

export default rootRoumu


// WEBPACK FOOTER //
// ./src/sagas/roumu.js